import { Grid } from "@material-ui/core";
import React from "react";
import { EnumStatisticType } from "../../../../../server/routes/statistic/types";
import Item from "./Item";
import { StatisticFC, StatisticItem } from "./types";
import useLoading from "./useLoading";

const items: StatisticItem[] = [
  {
    type: EnumStatisticType.REVENUE,
    name: "Выручка",
    today: {
      suffix: String.fromCharCode(8381),
    },
    month: {
      suffix: String.fromCharCode(8381),
    },
  },
  {
    type: EnumStatisticType.ORDERS,
    name: "Заказы",
    today:{suffix: 'шт.'},
    month:{suffix: 'шт.'}
  },
  {
    type: EnumStatisticType.AVERAGE_СHECK,
    name: "Средний чек",
    today: {
      suffix: String.fromCharCode(8381),
    },
    month: {
      suffix: String.fromCharCode(8381),
    },
  },
  {
    type: EnumStatisticType.MARGINALITY,
    name: "Маржинальность",
    today: {
      suffix: String.fromCharCode(8381),
    },
    month: {
      suffix: String.fromCharCode(8381),
    },
  },
];

const Statistic: StatisticFC = () => {
  const { loading, statistic } = useLoading();
  return (
    <Grid container spacing={1}>
      {items.map((item) => (
        <Item
          key={item.type}
          name={item.name}
          today={item.today}
          month={item.month}
          type={item.type}
          isLoading={loading}
          statistic={statistic ? statistic[item.type] : undefined}
        />
      ))}
    </Grid>
  );
};

export default Statistic;
